module.exports = __webpack_public_path__ + "fonts/ionicons.f20ea73.woff";